export default {"src":"/_next/static/media/BRF.38aab619.svg","height":18,"width":18};